import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';
import { ReportingGetLatestTransactionsRequest } from 'bff/client';

export const getLatestTransactions = (request: ReportingGetLatestTransactionsRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['latestTransactions'],
    queryFn: () => reportingApi.reportingGetLatestTransactions(request),
    select: (response) => response.data?.latestTransactions
  });
};
